import browser from 'imports/browser-detect'
let stickSite = {
    browser:browser(),
    init: function () {
        //add browser name
        if (stickSite.browser) {
            $('body').addClass("browser_" + stickSite.browser.name);
            if (stickSite.browser.mobile) {
                $('body').addClass("device-mobile")
            } else {
                $('body').addClass("device-notmobile")
            }
        }

        //mobile stuff
        $('.ui-link').removeClass('ui-link')

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault()
        })
    },

}
export default stickSite
